<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="d-flex flex-wrap flex-wrap align-items-center justify-content-between">
          <div>
            <h4 class="mb-3">请求变更记录<small>(요청 변경 내역)</small></h4>
            <p class="mb-0">可确认并处理货主请求的变更记录<small>(화주가 요청한 변경 내역을 확인하고 처리할 수 있습니다.)</small></p>
          </div>
        </div>
      </div>
      <div class="col-lg-12">
        <b-card>
          <form @submit.prevent="search">
            <div class="row">
              <div class="col-md-12">
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="customRadio7" name="customRadio-2" class="custom-control-input" v-model="selectdate"
                    value="today" @change="changedate()">
                  <label class="custom-control-label" for="customRadio7">今天<small>(오늘)</small></label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="customRadio8" name="customRadio-2" class="custom-control-input" v-model="selectdate"
                    value="week" @change="changedate()">
                  <label class="custom-control-label" for="customRadio8">最近7天<small>(최근7일)</small></label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="customRadio9" name="customRadio-2" class="custom-control-input" v-model="selectdate"
                    value="month" @change="changedate()">
                  <label class="custom-control-label" for="customRadio9">最近1个月<small>(최근1개월)</small></label>
                </div>
              </div>
              <div class="col-md-12 d-flex align-items-center">
                <b-input-group>
                  <select class="custom-select col-md-2" v-model="selectoption">
                    <option value="변경일">变更日(변경일)</option>
                  </select>
                  <b-form-datepicker id="example-datepicker1" size="sm" v-model="startdate"></b-form-datepicker>
                  <p>~</p>
                  <b-form-datepicker id="example-datepicker2" size="sm" v-model="enddate"></b-form-datepicker>
                </b-input-group>
                <b-form-input type="text" class="form-control w-25 ml-3" list="my-list-id" placeholder="货主ID(업체ID)"
                  @keyup.enter="importtextchange($event)" v-model="업체명"></b-form-input>
                <datalist id="my-list-id">
                  <option v-for="companyid in companyids" :key="companyid">{{ companyid }}</option>
                </datalist>
                <div class="custom-control custom-switch custom-control-inline w-25 ml-2">
                  <input type="checkbox" class="custom-control-input" id="customSwitch1" v-model="unconfirmedOnly">
                  <label class="custom-control-label" for="customSwitch1">仅查看未确认<small>(미확인 내역만 조회)</small></label>
                </div>
              </div>
            </div>
            <button type="button" class="btn btn-primary mr-2 mt-2" @click="search">搜索<small>(검색)</small></button>
            <b-spinner v-if="showspinner" label="Loading..."></b-spinner>
          </form>
        </b-card>
      </div>
      <div class="col-lg-12" v-if="showChanges">
        <div class="p-3 mb-3">
          <div class="row">
            <b-button variant="outline-primary" class="mb-1 mr-2" @click="showAll">
              全部<small>(전체)</small> <b-badge variant="primary" class="ml-2">{{ total }}</b-badge>
            </b-button>
            <b-button variant="outline-danger" class="mb-1 mr-2" @click="showUnconfirmed">
              未确认<small>(미확인)</small><b-badge variant="danger" class="ml-2">{{ unconfirmed }}</b-badge>
            </b-button>
            <b-button variant="outline-success" class="mb-1 mr-2" @click="showConfirmed">
              已确认<small>(확인완료)</small><b-badge variant="success" class="ml-2">{{ confirmed }}</b-badge>
            </b-button>
          </div>
        </div>

        <!-- 선택된 항목 일괄 처리 버튼 -->
        <div class="mb-3" v-if="selectedItems.length > 0">
          <b-button variant="success" @click="confirmSelectedChanges">
            确认处理所选 {{ selectedItems.length }} 项<small>(선택한 {{ selectedItems.length }}개 항목 확인 처리)</small>
          </b-button>
        </div>

        <!-- 변경 내역 테이블 -->
        <CDataTable
            storage-key="logisReqChanges" :headers="headers" :items="filteredChangesList" v-model="selectedItems" :show-select="true" itemKey="_id">
          <template v-slot:changeDate="{ item }">
            {{ formatDate(item.changeDate) }}
          </template>
          <template v-slot:상품명="{ item }">
            <div class="d-flex align-items-center p-1">
              <img :src="item.등록이미지" class="img-fluid rounded avatar-80 mr-3" alt="image">
              <div>
                {{ item.상품명 }}
                <p class="mb-0" style="color: #676E8A"><small>{{ item.SKUID }}</small></p>
                <p class="mb-0" style="color: #676E8A"><small>{{ item.바코드 }}</small></p>
              </div>
            </div>
          </template>
          <template v-slot:changes="{ item }">
            <div v-for="(change, field) in item.changes" :key="field" class="mb-1">
              <strong>{{ getFieldName(field) }}:</strong>
              <span class="text-danger">{{ formatValue(change.변경전) }}</span> →
              <span class="text-success">{{ formatValue(change.변경후) }}</span>
            </div>
          </template>
          <template v-slot:confirmed="{ item }">
            <b-badge v-if="item.confirmed" variant="success">已确认(확인완료)</b-badge>
            <b-badge v-else variant="danger">未确认(미확인)</b-badge>
            <div v-if="item.confirmed" class="mt-1">
              <small>{{ formatDate(item.confirmedDate) }}</small><br>
              <small>{{ item.confirmedBy }}</small>
            </div>
          </template>
          <template v-slot:action="{ item }">
            <div class="d-flex align-items-center list-action">
              <a class="badge bg-success mr-2" data-toggle="tooltip" v-b-tooltip.top title="确认处理(확인 처리)"
                href="javascript:void(0)" @click="confirmChange(item)"
                style="width: 30px; height: 30px; display: flex; justify-content: center; align-items: center"
                v-if="!item.confirmed">
                <i class="ri-check-line mr-0"></i>
              </a>
              <a class="badge badge-info mr-2" data-toggle="tooltip" v-b-tooltip.top title="查看详情(상세 보기)"
                href="javascript:void(0)" v-b-modal="'modalDetail' + item._id"
                style="width: 30px; height: 30px; display: flex; justify-content: center; align-items: center">
                <i class="ri-eye-line mr-0"></i>
              </a>
              <a class="badge badge-primary mr-2" data-toggle="tooltip" v-b-tooltip.top title="查看原始请求(원본 요청 보기)"
                href="javascript:void(0)" @click="viewOriginalRequest(item)"
                style="width: 30px; height: 30px; display: flex; justify-content: center; align-items: center">
                <i class="ri-file-list-line mr-0"></i>
              </a>
            </div>

            <!-- 상세 정보 모달 -->
            <b-modal :id="'modalDetail' + item._id" size="xl" scrollable title="变更记录详情(변경 내역 상세)" ok-title="确认(확인)"
              cancel-title="关闭(닫기)" @ok="handleDetailModalOk(item)" class="detail-modal">
              <div class="row">
                <div class="col-md-6">
                  <h5>商品信息<small>(상품 정보)</small></h5>
                  <div class="d-flex align-items-center mb-3">
                    <img :src="item.등록이미지" class="img-fluid rounded mr-3" alt="image" style="max-width: 100px;">
                    <div>
                      <p class="mb-1"><strong>商品名(상품명):</strong> {{ item.상품명 }}</p>
                      <p class="mb-1"><strong>SKUID:</strong> {{ item.SKUID }}</p>
                      <p class="mb-1"><strong>条码(바코드):</strong> {{ item.바코드 }}</p>
                    </div>
                  </div>

                  <h5>变更信息<small>(변경 정보)</small></h5>
                  <p><strong>变更日(변경일):</strong> {{ formatDate(item.changeDate) }}</p>
                  <p><strong>变更者(변경자):</strong> {{ item.changedBy }}</p>

                  <h5>确认信息<small>(확인 정보)</small></h5>
                  <div v-if="item.confirmed">
                    <p><strong>确认日(확인일):</strong> {{ formatDate(item.confirmedDate) }}</p>
                    <p><strong>确认人(확인자):</strong> {{ item.confirmedBy }}</p>
                    <p v-if="item.confirmNote"><strong>确认备注(확인 메모):</strong> {{ item.confirmNote }}</p>
                  </div>
                  <div v-else>
                    <p class="text-danger">尚未确认<small>(아직 확인되지 않았습니다.)</small></p>
                    <div class="form-group">
                      <label for="confirmNote">确认备注<small>(확인 메모)</small></label>
                      <textarea class="form-control" id="confirmNote" rows="3" v-model="confirmNoteText"></textarea>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <h5>变更内容<small>(변경 내용)</small></h5>
                  <div class="table-responsive">
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th>项目<small>(항목)</small></th>
                          <th>变更前<small>(변경 전)</small></th>
                          <th>变更后<small>(변경 후)</small></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(change, field) in item.changes" :key="field">
                          <td><strong>{{ getFieldName(field) }}</strong></td>
                          <td class="text-danger">{{ formatValue(change.변경전) }}</td>
                          <td class="text-success">{{ formatValue(change.변경후) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </b-modal>
          </template>
        </CDataTable>


      </div>
    </div>

    <!-- 일괄 확인 처리 모달 -->
    <b-modal id="bulk-confirm-modal" title="批量确认处理(일괄 확인 처리)" @ok="handleBulkConfirm" ok-title="确认(확인)" cancel-title="取消(취소)">
      <p>确定要确认处理所选 {{ selectedItems.length }} 项吗?<small>(선택한 {{ selectedItems.length }}개 항목을 확인 처리하시겠습니까?)</small></p>
      <div class="form-group">
        <label for="bulkConfirmNote">确认备注(选填)<small>(확인 메모 (선택사항))</small></label>
        <textarea class="form-control" id="bulkConfirmNote" rows="3" v-model="bulkConfirmNote"></textarea>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios'
import CDataTable from '@/components/common/CDataTable.vue'

export default {
  components: {
    CDataTable
  },
  name: 'LogisReqChanges',
  data() {
    return {
      // 필터링 관련
      selectdate: 'week',
      startdate: '',
      enddate: '',
      selectoption: '변경일',
      업체명: '',
      companyids: [],
      unconfirmedOnly: true,

      // 데이터 관련
      showspinner: false,
      showChanges: false,
      changesList: [],
      filteredChangesList: [],
      selectedItems: [],

      // 통계 관련
      total: 0,
      confirmed: 0,
      unconfirmed: 0,



      // 모달 관련
      confirmNoteText: '',
      bulkConfirmNote: '',

      // 테이블 헤더
      headers: [
        { text: '变更日(변경일)', value: 'changeDate', align: 'center', width: 150, isSlot: true },
        { text: '货主ID(업체ID)', value: 'companyid', align: 'center', width: 100 },
        { text: '商品名(상품명)', value: '상품명', align: 'left', width: 300, isSlot: true },
        { text: '变更内容(변경내용)', value: 'changes', align: 'left', isSlot: true },
        { text: '变更者(변경자)', value: 'changedBy', align: 'center', width: 100 },
        { text: '确认状态(확인상태)', value: 'confirmed', align: 'center', width: 120, isSlot: true },
        { text: '操作(액션)', value: 'action', align: 'center', width: 120, isSlot: true }
      ]
    }
  },
  methods: {
    // 날짜 관련 메서드
    changedate() {
      const today = new Date()
      const endDate = new Date(today)
      let startDate = new Date(today)

      if (this.selectdate === 'today') {
        // 오늘
        this.startdate = this.formatDateForInput(today)
        this.enddate = this.formatDateForInput(today)
      } else if (this.selectdate === 'week') {
        // 최근 7일
        startDate.setDate(today.getDate() - 7)
        this.startdate = this.formatDateForInput(startDate)
        this.enddate = this.formatDateForInput(endDate)
      } else if (this.selectdate === 'month') {
        // 최근 1개월
        startDate.setMonth(today.getMonth() - 1)
        this.startdate = this.formatDateForInput(startDate)
        this.enddate = this.formatDateForInput(endDate)
      }
    },

    formatDateForInput(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },

    formatDate(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleString('ko-KR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })
    },

    // 검색 및 필터링 메서드
    search() {
      this.showspinner = true
      this.showChanges = false

      // 날짜 변환
      const start = new Date(this.startdate)
      start.setHours(0, 0, 0, 0)

      const end = new Date(this.enddate)
      end.setHours(23, 59, 59, 999)

      // API 호출 파라미터
      const params = {
        startdate: this.formatDateForAPI(start),
        enddate: this.formatDateForAPI(end),
        companyid: this.업체명,
        unconfirmedOnly: this.unconfirmedOnly
      }

      // API 호출
      console.log('API 호출 파라미터:', params)
      axios.post('/api/logis/reqchanges', params)
        .then(response => {
          console.log('API 응답:', response.data)
          if (response.data.success) {
            this.changesList = response.data.changes || []
            console.log('변경 내역 개수:', this.changesList.length)

            // 날짜 형식 변환 및 데이터 정렬
            this.changesList.forEach(item => {
              if (item.changeDate) {
                item.changeDate = new Date(item.changeDate)
              }
              if (item.confirmedDate) {
                item.confirmedDate = new Date(item.confirmedDate)
              }
            })

            // 최신 변경일 순으로 정렬
            this.changesList.sort((a, b) => b.changeDate - a.changeDate)

            this.filteredChangesList = [...this.changesList]
            this.calculateStats()
            this.showChanges = true
          } else {
            alert(response.data.message || '查询数据时出错(데이터 조회 중 오류가 발생했습니다.)')
          }
          this.showspinner = false
        })
        .catch(error => {
          console.error('API 호출 오류:', error)
          alert('查询数据时出错(데이터 조회 중 오류가 발생했습니다.)')
          this.showspinner = false
        })
    },

    // 통계 계산
    calculateStats() {
      this.total = this.changesList.length
      this.confirmed = this.changesList.filter(item => item.confirmed).length
      this.unconfirmed = this.total - this.confirmed
    },

    // 필터링 메서드
    showAll() {
      this.filteredChangesList = [...this.changesList]
    },

    showUnconfirmed() {
      this.filteredChangesList = this.changesList.filter(item => !item.confirmed)
    },

    showConfirmed() {
      this.filteredChangesList = this.changesList.filter(item => item.confirmed)
    },

    // 확인 처리 메서드
    confirmChange(item) {
      this.confirmNoteText = ''
      this.$bvModal.show('modalDetail' + item._id)
    },

    handleDetailModalOk(item) {
      if (item.confirmed) return

      const params = {
        requestId: item.requestId,
        changeId: item._id,
        confirmNote: this.confirmNoteText,
        confirmedBy: this.$store.state.user.name || this.$store.state.user.email
      }

      axios.post('/api/logis/confirmchange', params)
        .then(response => {
          if (response.data.success) {
            // 확인 처리 성공
            item.confirmed = true
            item.confirmedBy = params.confirmedBy
            item.confirmedDate = new Date()
            item.confirmNote = params.confirmNote

            // 통계 업데이트
            this.calculateStats()

            this.$bvToast.toast('变更记录已确认处理(변경 내역이 확인 처리되었습니다.)', {
              title: '确认完成(확인 완료)',
              variant: 'success',
              solid: true
            })
          } else {
            alert(response.data.message || '确认处理时出错(확인 처리 중 오류가 발생했습니다.)')
          }
        })
        .catch(error => {
          console.error('API 호출 오류:', error)
          alert('确认处理时出错(확인 처리 중 오류가 발생했습니다.)')
        })
    },

    // 일괄 확인 처리
    confirmSelectedChanges() {
      if (this.selectedItems.length === 0) return

      // 이미 확인된 항목 필터링
      const unconfirmedItems = this.selectedItems.filter(item => !item.confirmed)

      if (unconfirmedItems.length === 0) {
        this.$bvToast.toast('所选项目均已确认处理(선택한 항목이 모두 이미 확인 처리되었습니다.)', {
          title: '提示(알림)',
          variant: 'warning',
          solid: true
        })
        return
      }

      this.selectedItems = unconfirmedItems
      this.$bvModal.show('bulk-confirm-modal')
    },

    handleBulkConfirm() {
      if (this.selectedItems.length === 0) return

      const params = {
        changes: this.selectedItems.map(item => ({
          requestId: item.requestId,
          changeId: item._id
        })),
        confirmNote: this.bulkConfirmNote,
        confirmedBy: this.$store.state.user.name || this.$store.state.user.email
      }

      axios.post('/api/logis/confirmchanges', params)
        .then(response => {
          if (response.data.success) {
            // 확인 처리 성공
            this.selectedItems.forEach(item => {
              item.confirmed = true
              item.confirmedBy = params.confirmedBy
              item.confirmedDate = new Date()
              item.confirmNote = params.confirmNote
            })

            // 통계 업데이트
            this.calculateStats()

            this.$bvToast.toast(`已确认处理 ${this.selectedItems.length} 项(${this.selectedItems.length}개 항목이 확인 처리되었습니다.)`, {
              title: '批量确认完成(일괄 확인 완료)',
              variant: 'success',
              solid: true
            })

            // 선택 초기화
            this.selectedItems = []
            this.bulkConfirmNote = ''
          } else {
            alert(response.data.message || '批量确认处理时出错(일괄 확인 처리 중 오류가 발생했습니다.)')
          }
        })
        .catch(error => {
          console.error('API 호출 오류:', error)
          alert('批量确认处理时出错(일괄 확인 처리 중 오류가 발생했습니다.)')
        })
    },

    // 원본 요청 보기
    viewOriginalRequest(item) {
      // 원본 요청 페이지로 이동
      console.log('원본보기 버튼 클릭 - requestId:', item.requestId);
      this.$router.push({
        name: 'logis.logisreqpurchase',
        query: { requestId: item.requestId }
      })
    },



    // 유틸리티 메서드
    getFieldName(field) {
      // 필드명 한글화
      const fieldMap = {
        // 기본 필드
        '구매요청수량': '구매요청수량',
        '판매구성수량': '판매구성수량',
        '묶음구성여부': '묶음구성여부',
        '묶음구성수량': '묶음구성수량',
        '묶음대상바코드': '묶음대상바코드',
        '신고영문명': '신고영문명',
        '신고가격': '신고가격',
        'HSCODE': 'HSCODE',
        '진행현황': '진행현황',
        '재고동봉': '재고동봉',
        '등록이미지': '등록이미지',
        '요청사항': '요청사항',
        'reqtype': '요청유형',
        'sizeX': '가로(cm)',
        'sizeY': '세로(cm)',
        'sizeZ': '높이(cm)',
        'weight': '무게(g)',

        // 옵션 관련 필드
        '옵션1_중국어': '옵션1(중국어)',
        '옵션2_중국어': '옵션2(중국어)',

        // 요청내역 필드
        'reqcontent': '요청사항(물류)',
        'reqcontentPurchase': '요청사항(구매)',
        'destination': '도착지',
        'exportType': '출고형태',
        'customsType': '통관형태',
        'default': '기본검수',
        'poarrange': '발주대행',
        'barcode': '바코드부착',
        'sticker': '스티커부착',
        'sewing': '봉제처리',
        'stamp': '스탬프작업',
        'tag': '택작업',
        'opp': 'OPP포장',
        'LDPE': 'LDPE포장',
        'airpacking': '에어포장',
        'masking': '마스킹',
        'auto': '자동발주',

        // 요청내역 중첩 필드
        '요청내역.default': '기본검수',
        '요청내역.poarrange': '발주대행',
        '요청내역.한글표시사항': '한글표시사항',
        '요청내역.barcode': '바코드부착',
        '요청내역.sticker': '스티커부착',
        '요청내역.sewing': '봉제처리',
        '요청내역.stamp': '스탬프작업',
        '요청내역.tag': '택작업',
        '요청내역.reqcontent': '요청사항(물류)',
        '요청내역.reqcontentPurchase': '요청사항(구매)',
        '요청내역.opp': 'OPP포장',
        '요청내역.LDPE': 'LDPE포장',
        '요청내역.airpacking': '에어포장',
        '요청내역.exportType': '출고형태',
        '요청내역.destination': '도착지',
        '요청내역.customsType': '통관형태',
        '요청내역.masking': '마스킹',
        '요청내역.auto': '자동발주',

        // 한글표시사항 필드
        '한글표시사항.제품명': '제품명',
        '한글표시사항.수입원/판매원': '수입원/판매원',
        '한글표시사항.제조원': '제조원',
        '한글표시사항.제조국': '제조국',
        '한글표시사항.내용량': '내용량',
        '한글표시사항.원료명및성분명(재질)': '원료명및성분명(재질)',
        '한글표시사항.상품유형': '상품유형',
        '한글표시사항.사용시주의사항': '사용시주의사항',
        '한글표시사항.사용기준': '사용기준'
      }

      // 한국어 필드명 → 중국어 병기 (중국 물류 담당자용). 없는 키는 한국어만 표시
      const cnMap = {
        '상품명': '商品名',
        '상품명init': '商品名(初始)',
        '바코드': '条码',
        '구매요청수량': '采购数量',
        '판매구성수량': '销售组合数量',
        '묶음구성여부': '是否组合装',
        '묶음구성수량': '组合装数量',
        '묶음대상바코드': '组合对象条码',
        '신고영문명': '申报英文品名',
        '신고가격': '申报价格',
        'HSCODE': 'HS编码',
        '진행현황': '进度状态',
        '재고동봉': '库存同捆',
        '등록이미지': '登记图片',
        '옵션이미지': '选项图片',
        '요청사항': '要求事项',
        '요청유형': '请求类型',
        '요청일': '请求日',
        '요청변경': '请求变更',
        '가로(cm)': '长(cm)',
        '세로(cm)': '宽(cm)',
        '높이(cm)': '高(cm)',
        '무게(g)': '重量(g)',
        '옵션1(중국어)': '选项1(中文)',
        '옵션2(중국어)': '选项2(中文)',
        '요청사항(물류)': '物流要求',
        '요청사항(구매)': '采购要求',
        '도착지': '目的地',
        '출고형태': '出库形式',
        '통관형태': '清关方式',
        '통관방법': '清关方式',
        '기본검수': '基本验货',
        '발주대행': '代理下单',
        '바코드부착': '贴条码',
        '스티커부착': '贴标签',
        '봉제처리': '缝标',
        '스탬프작업': '盖章',
        '택작업': '挂吊牌',
        'OPP포장': 'OPP袋包装',
        'LDPE포장': 'LDPE袋包装',
        '에어포장': '气泡膜包装',
        '마스킹': '遮盖处理',
        '자동발주': '自动下单',
        '한글표시사항': '韩文标签',
        '제품명': '产品名称',
        '수입원/판매원': '进口商/销售商',
        '제조원': '制造商',
        '제조국': '原产国',
        '내용량': '净含量',
        '원료명및성분명(재질)': '原料及成分(材质)',
        '상품유형': '商品类型',
        '사용시주의사항': '使用注意事项',
        '사용기준': '使用标准',
        '협의단가': '议价单价',
        '협의총금액': '议价总金额',
        '협의ID': '议价ID',
        '협의내용': '议价内容',
        '구매재고': '采购库存',
        '구매링크': '采购链接',
        '구매링크init': '采购链接(初始)',
        '구매id': '采购ID',
        '구매sku': '采购SKU',
        '구매가격': '采购价格',
        '구매취소': '取消采购',
        '구매취소내용': '取消采购内容',
        '주문번호': '订单号',
        '상품주문번호': '商品订单号',
        '화주주문번호': '货主订单号',
        '1688주문번호': '1688订单号',
        '주문시간': '下单时间',
        '주문수량': '下单数量',
        '주문생성여부': '是否已下单',
        '협상전_단가': '议价前单价',
        '협상전_수량': '议价前数量',
        '협상전_배송비': '议价前运费',
        '협상전_주문배송비': '议价前订单运费',
        '협상전_상품금액': '议价前商品金额',
        '협상전_총금액': '议价前总金额',
        '협상후_수량': '议价后数量',
        '협상후_배송비': '议价后运费',
        '협상후_주문배송비': '议价后订单运费',
        '협상후_상품금액': '议价后商品金额',
        '협상후_할인금액': '议价后优惠金额',
        '협상후_실결제금액': '议价后实付金额',
        '협상후_총금액': '议价后总金额',
        '가격확인시간': '价格确认时间',
        '가격수정시간': '改价时间',
        '가격수정알림': '改价通知',
        '입금여부': '是否付款',
        '입금일시': '付款时间',
        '최종결제여부': '是否最终付款',
        '최종결제시간': '最终付款时间',
        '물류방법': '物流方式',
        '물류코드': '物流公司代码',
        '물류상태': '物流状态',
        '운송장번호': '快递单号',
        '운송장번호목록': '快递单号列表',
        '발송시간': '发货时间',
        '수령확인': '签收确认',
        '수령확인시간': '签收时间',
        '업데이트시간': '更新时间',
        '매칭상태': '匹配状态',
        '업체명': '公司名',
        '주소': '地址',
        '연락처': '联系方式',
        '결제금액_KRW': '付款金额(KRW)',
        '부가세': '增值税',
        '최종금액합계_KRW': '最终合计金额(KRW)',
        '생성일': '创建日期'
      }

      let ko = field
      // 중첩된 필드 처리 (예: '요청내역.sewing')
      if (fieldMap[field]) {
        ko = fieldMap[field]
      } else if (field.includes('.')) {
        // 점(.)으로 구분된 필드 처리
        const parts = field.split('.')
        const lastPart = parts[parts.length - 1]
        ko = fieldMap[lastPart] || lastPart
      }

      const cn = cnMap[ko]
      return cn ? `${cn}(${ko})` : ko
    },

    formatValue(value) {
      if (value === undefined || value === null) return '-'
      if (typeof value === 'boolean') return value ? 'O' : 'X'
      if (typeof value === 'object') return JSON.stringify(value)
      return value.toString()
    },

    formatDateForAPI(date) {
      if (!date) return ''
      const d = new Date(date)
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
    },

    // 회사 ID 목록 가져오기
    importCompanyIds() {
      axios.post('/api/getcompanyids', {})
        .then(result => {
          if (result.data.요청결과 === 'success') {
            result.data.result.forEach(e => {
              if (e.auth.showimport) {
                if (!this.companyids.includes(e.companyid)) {
                  this.companyids.push(e.companyid)
                }
              }
            })
          } else {
            console.error(result.data.사유)
          }
        })
        .catch(error => {
          console.error('회사 ID 가져오기 실패:', error)
        })
    },

    importtextchange(event) {
      if (event.keyCode === 13 && this.업체명 !== '') {
        this.search()
      }
    }
  },
  mounted() {
    // 기본 날짜 설정 (최근 30일)
    const today = new Date()
    const thirtyDaysAgo = new Date()
    thirtyDaysAgo.setDate(today.getDate() - 30)

    this.startdate = this.formatDateForAPI(thirtyDaysAgo)
    this.enddate = this.formatDateForAPI(today)

    this.importCompanyIds() // 회사 ID 목록 가져오기
    this.search() // 초기 데이터 로드
  }
}
</script>

<style scoped>
.badge {
  cursor: pointer;
}

.detail-modal .modal-dialog {
  max-width: 90%;
}

.text-danger {
  color: #dc3545;
}

.text-success {
  color: #28a745;
}
</style>
